<template>
  <div class="game-info">
    <div class="team-vs-score">
      <div class="home">
        <div class="logo">
          <div class="team-line" :class="{ 'home-red': isHomeRed && isHomeRed !== -1, 'home-blue': !isHomeRed && isHomeRed !== -1 }">
            <img :src="coverInfo.home_logo" @error="onKogTeamLogoError" alt="">
          </div>
        </div>
        <div class="score-wrap">
          <div class="money" v-if="moneyDValue > 0">
            <img src="../../../assets/images/gaming/money-up-icon.png" alt="" />
            <span>{{ (homeMoney - awayMoney || 0) | formatNumber }}</span>
            <img src="../../../assets/images/gaming/money-icon.png" alt="" />
          </div>
          <div class="score">{{ homeKillCount || 0 }}</div>
        </div>
      </div>
      <div class="time">{{ coverInfo.duration | secToMin }}</div>
      <div class="away">
        <div class="score-wrap">
          <div class="score">{{ awayKillCount || 0 }}</div>
          <div class="money" v-if="moneyDValue < 0">
            <img src="../../../assets/images/gaming/money-up-icon.png" alt="" />
            <span>{{ (awayMoney - homeMoney || 0) | formatNumber }}</span>
            <img src="../../../assets/images/gaming/money-icon.png" alt="" />
          </div>
        </div>
        <div class="logo">
          <div class="team-line" :class="{'away-blue': isHomeRed && isHomeRed !== -1, 'away-red': !isHomeRed && isHomeRed !== -1 }">
            <img :src="coverInfo.away_logo" @error="onLolTeamLogoError" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="info-detail">
      <div class="left">
        <div class="info-item">
          <div class="home">
            <div class="num">{{ homeSmallDragon || 0 }}</div>
            <div class="line">
              <div class="active" :class="{ 'home-red-team-color': isHomeRed && isHomeRed !== -1, 'home-blue-team-color': !isHomeRed && isHomeRed !== -1 }"  :style="{width: homeSmallRange * 100 + '%'}"></div>
            </div>
          </div>
          <div class="title">暴君</div>
          <div class="away">
            <div class="line">
              <div class="active" :class="{ 'away-blue-team-color': isHomeRed && isHomeRed !== -1, 'away-red-team-color': !isHomeRed && isHomeRed !== -1 }" :style="{width: awaySmallRange * 100 + '%'}"></div>
            </div>
            <div class="num">{{ awaySmallDragon || 0 }}</div>
          </div>
        </div>
        <div class="info-item">
          <div class="home">
            <div class="num">{{ homeBigDragon || 0 }}</div>
            <div class="line">
              <div class="active" :class="{ 'home-red-team-color': isHomeRed && isHomeRed !== -1, 'home-blue-team-color': !isHomeRed && isHomeRed !== -1 }"  :style="{width: homeBigRange * 100 + '%'}"></div>
            </div>
          </div>
          <div class="title">主宰</div>
          <div class="away">
            <div class="line">
              <div class="active" :class="{ 'away-blue-team-color': isHomeRed && isHomeRed !== -1, 'away-red-team-color': !isHomeRed && isHomeRed !== -1 }" :style="{width: awayBigRange * 100 + '%'}"></div>
            </div>
            <div class="num">{{ awayBigDragon || 0 }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="info-item">
          <div class="home">
            <div class="num">{{ homeCreepScore || 0 }}</div>
            <div class="line">
              <div class="active" :class="{ 'home-red-team-color': isHomeRed && isHomeRed !== -1, 'home-blue-team-color': !isHomeRed && isHomeRed !== -1 }"  :style="{width: homeCreepRange * 100 + '%'}"></div>
            </div>
          </div>
          <div class="title">推塔</div>
          <div class="away">
            <div class="line">
              <div class="active" :class="{ 'away-blue-team-color': isHomeRed && isHomeRed !== -1, 'away-red-team-color': !isHomeRed && isHomeRed !== -1 }" :style="{width: awayCreepRange * 100 + '%'}"></div>
            </div>
            <div class="num">{{ awayCreepScore || 0 }}</div>
          </div>
        </div>
        <div class="info-item">
          <div class="home">
            <div class="num">{{ (homeMoney || 0) | formatNumber }}</div>
            <div class="line">
              <div class="active" :class="{ 'home-red-team-color': isHomeRed && isHomeRed !== -1, 'home-blue-team-color': !isHomeRed && isHomeRed !== -1 }"  :style="{width: homeMoneyRange * 100 + '%'}"></div>
            </div>
          </div>
          <div class="title">经济</div>
          <div class="away">
            <div class="line">
              <div class="active" :class="{ 'away-blue-team-color': isHomeRed && isHomeRed !== -1, 'away-red-team-color': !isHomeRed && isHomeRed !== -1 }" :style="{width: awayMoneyRange * 100 + '%'}"></div>
            </div>
            <div class="num">{{ (awayMoney || 0) | formatNumber }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'LolGameInfo',
  props: {
    coverInfo: {
      type: Object
    },
    gameInfo: {
      type: Object
    }
  },
  filters: {
    secToMin(sec) {
      // 将秒数除以60，得到分钟数
      let min = sec / 60;
      // 使用 Math.floor 方法向下取整
      min = Math.floor(min);
      const second = sec % 60 < 10 ? '0'  + sec % 60 : sec % 60
      // 返回结果
      return `${min}:${second}`;
    },
    formatNumber(num) {
      return num >= 1000 ? (num / 1000).toFixed(1) + 'k' : num;
    }
  },
  computed: {
    isHomeRed () {
      const side = this.gameInfo.home.team && Number(this.gameInfo.home.team.side) || 0
      return Number(side)
    },
    homeMoney () {
      const money = this.gameInfo.home.team && this.gameInfo.home.team.money || 0
      return money
    },
    awayMoney () {
      const money = this.gameInfo.away.team && this.gameInfo.away.team.money || 0
      return money
    },
    homeKillCount () {
      const count = this.gameInfo.home.team && this.gameInfo.home.team.kill_count || 0
      return count
    },
    awayKillCount () {
      const count = this.gameInfo.away.team && this.gameInfo.away.team.kill_count || 0
      return count
    },
    homeSmallDragon () {
      const count = this.gameInfo.home.team && this.gameInfo.home.team.tyrants_count || 0
      return count
    },
    awaySmallDragon () {
      const count = this.gameInfo.away.team && this.gameInfo.away.team.tyrants_count || 0
      return count
    },
    homeBigDragon () {
      const count = this.gameInfo.home.team && this.gameInfo.home.team.dominates_count || 0
      return count
    },
    awayBigDragon () {
      const count = this.gameInfo.away.team && this.gameInfo.away.team.dominates_count || 0
      return count
    },
    smallDragonCount () {
      const homeCount = this.gameInfo.home.team && this.gameInfo.home.team.tyrants_count || 0
      const awayCount = this.gameInfo.away.team && this.gameInfo.away.team.tyrants_count || 0
      return homeCount + awayCount
    },
    bigDragonCount () {
      const homeCount = this.gameInfo.home.team && this.gameInfo.home.team.dominates_count || 0
      const awayCount = this.gameInfo.away.team && this.gameInfo.away.team.dominates_count || 0
      return homeCount + awayCount
    },
    moneyCount () {
      const homeCount = this.gameInfo.home.team && this.gameInfo.home.team.money || 0
      const awayCount = this.gameInfo.away.team && this.gameInfo.away.team.money || 0
      return homeCount + awayCount
    },
    homeCreepScore () {
      const count = this.gameInfo.home.team && this.gameInfo.home.team.tower_success_count || 0
      return count
    },
    awayCreepScore () {
      const count = this.gameInfo.away.team && this.gameInfo.away.team.tower_success_count || 0
      return count
    },
    creepScore () {
      return this.homeCreepScore + this.awayCreepScore
    },
    moneyDValue () {
      return this.homeMoney - this.awayMoney
    },
    homeSmallRange () {
      if (this.smallDragonCount < 1) {
        return 0
      }
      return this.homeSmallDragon / this.smallDragonCount
    },
    awaySmallRange () {
      if (this.smallDragonCount < 1) {
        return 0
      }
      return this.awaySmallDragon / this.smallDragonCount
    },
    homeBigRange () {
      if (this.bigDragonCount < 1) {
        return 0
      }
      return this.homeBigDragon / this.bigDragonCount
    },
    awayBigRange () {
      if (this.bigDragonCount < 1) {
        return 0
      }
      return this.awayBigDragon / this.bigDragonCount
    },
    homeCreepRange () {
      if (this.creepScore < 1) {
        return 0
      }
      return this.homeCreepScore / this.creepScore
    },
    awayCreepRange () {
      if (this.creepScore < 1) {
        return 0
      }
      return this.awayCreepScore / this.creepScore
    },
    homeMoneyRange () {
      if (this.moneyCount < 1) {
        return 0
      }
      return this.homeMoney / this.moneyCount
    },
    awayMoneyRange () {
      if (this.moneyCount < 1) {
        return 0
      }
      return this.awayMoney / this.moneyCount
    }
  }
}
</script>

<style lang="less" scoped>
.home-red-team-color {
  background: linear-gradient(90deg, #F55E1D 0%, #D40C2D 100%);
}
.home-blue-team-color {
  background: linear-gradient(90deg, #78EFF9 0%, #3069C1 100%);
}
.away-red-team-color {
  background: linear-gradient(-90deg, #F55E1D 0%, #D40C2D 100%);
}
.away-blue-team-color {
  background: linear-gradient(-90deg, #78EFF9 0%, #3069C1 100%);
}
.game-info {
  height: 134px;
  background: #2B2B2B;
  .team-vs-score {
    display: flex;
    gap: 9px;
    align-items: center;
    padding-top: 13px;
    .time {
      width: 56px;
      text-align: center;
      font-size: 14px;
      color: #FDFDFA;
    }
    .home, .away {
      flex: 1;
      display: flex;
      justify-content: space-between;
      .team-line {
        width: 150px;
        height: 54px;
        position: relative;
        justify-content: center;
        align-items: center;
        display: flex;
        &.home-red {
          &::before {
            position: absolute;
            content: '';
            left: 0;
            height: 100%;
            top: 0;
            width: 10px;
            background: #E43325;
          }
          background: linear-gradient(-90deg, rgba(47,103,191,0) 0%, rgba(202,0,43,.65) 100%);
        }
        &.home-blue {
          &::before {
            position: absolute;
            content: '';
            left: 0;
            height: 100%;
            top: 0;
            width: 10px;
            background: #3E89FF;
          }
          background: linear-gradient(-90deg, rgba(47,103,191,0) 0%, rgba(0,93,238,0.65) 100%);
        }
        &.away-red {
          &::before {
            position: absolute;
            content: '';
            right: 0;
            height: 100%;
            top: 0;
            width: 10px;
            background: #E43325;
          }
          background: linear-gradient(90deg, rgba(47,103,191,0) 0%, rgba(202,0,43,.65) 100%);
        }
        &.away-blue {
          &::before {
            position: absolute;
            content: '';
            right: 0;
            height: 100%;
            top: 0;
            width: 10px;
            background: #3E89FF;
          }
          background: linear-gradient(90deg, rgba(47,103,191,0) 0%, rgba(0,93,238,0.65) 100%);
        }
      }
      .logo {
        display: flex;
        align-items: center;
        img {
          width: 38px;
          height: 38px;
          border-radius: 4px;
          padding: 2px;
          background-color: #fff;
        }
      }
      .score-wrap {
        display: flex;
        align-items: center;
        gap: 5px;
        .money {
          display: flex;
          gap: 4px;
          img {
            width: 17px;
            height: 17px;
          }
          span {
            font-size: 14px;
            color: #FFA347;
            line-height: 17px;
          }
        }
        .score {
          width: 40px;
          height: 40px;
          border-radius: 5px;
          background: #fff;
          text-align: center;
          line-height: 40px;
          font-size: 26px;
          color: #000;
        }
      }
    }
  }
  .info-detail {
    display: flex;
    margin-top: 13px;
    .left, .right {
      flex: 1;
      .info-item {
        display: flex;
        gap: 20px;
        justify-content: center;
        margin-bottom: 5px;
        .home, .away {
          flex: 1;
          display: flex;
          align-items: center;
          gap: 4px;
          .line {
            width: 100px;
            height: 8px;
            border-radius: 8px;
            position: relative;
            background-color: rgba(204, 204, 204, .5);
            .active {
              position: absolute;
              height: 8px;
              border-radius: 8px;
              top: 0;
            }
          }
          .num {
            font-size: 14px;
            color: #FDFDFA;
          }
        }
        .home {
          justify-content: end;
          .line {
            .active {
              right: 0;
            }
          }
        }
        .away {
          .line {
            .active {
              left: 0;
            }
          }
        }
        .title {
          width: 30px;
          text-align: center;
          line-height: 20px;
          font-size: 14px;
          color: #FDFDFA;
        }
      }
    }
  }
}
</style>